export default __webpack_public_path__ + "static/media/delphus.a57fca38.png";